import React from "react";
import {
  Box,
  Typography,
  Container,
  Button,
  ThemeProvider,
  createTheme,
  CssBaseline,
} from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";

const theme = createTheme({
  palette: {
    primary: { main: "#0f63a5" },
  },
  // typography: {
  //   fontFamily: `"Playfair Display", serif`,
  // },
});

const CultureSection: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <Box
        sx={{
          height: "88vh",
          width: "100%",
          position: "relative",
          backgroundImage: `url("https://dprstorage.b-cdn.net/RW/leadgen/DSC00636.JPG")`, // 🔥 place image in public/images
          backgroundSize: "cover",
          backgroundPosition: "center ",
          display: "flex",
          alignItems: "center",
        }}
      >
        {/* 🔥 Dark Overlay */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.65))",
          }}
        />

        {/* 🔥 Content */}
        <Container
          sx={{
            position: "relative",
            zIndex: 2,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              maxWidth: "800px",
              textAlign: "center",
              color: "#fff",
            }}
          >
            {/* Title */}
            <Typography
              sx={{
                fontSize: { xs: "2.2rem", md: "3.5rem" },
                fontWeight: 500,
                mb: 3,
              }}
            >
              Culture of Excellence
            </Typography>

            {/* Description */}
            <Typography
              sx={{
                fontSize: { xs: "1rem", md: "1.2rem" },
                lineHeight: 1.8,
                color: "rgba(255,255,255,0.85)",
                mb: 4,
              }}
            >
              Our workspace is designed for innovation. Premium facilities,
              collaborative environments, and a culture that celebrates
              achievement.
            </Typography>

            {/* CTA */}
            <Button
              endIcon={<ArrowOutwardIcon />}
              sx={{
                color: "#fff",
                textTransform: "none",
                fontSize: "1rem",
                borderBottom: "1px solid #fff",
                borderRadius: 0,
                padding: 0,

                "&:hover": {
                  color: "#0f63a5",
                  borderBottom: "1px solid #0f63a5",
                  background: "transparent",
                },
              }}
            >
              Explore Our Culture
            </Button>
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default CultureSection;